export class Country {
  constructor(
    public readonly id: number,
    public readonly libelle: string,
    public readonly code: string,
  ) {}
}
